<template>
  <div v-show="visible" class="home-act-tip" @click="clickMe">
    <img :src="actIconImg" width="36" height="36" alt="">
  </div>
</template>

<script>
  import _ from 'underscore'

  import { os } from '../util/platform'
  import LazyImg from '../components/lazy-img'
  import { resolveActionPath } from '../util/function'
  export default {
    name: 'home-act-tip',
    data() {
      return {
        isScrolling: false
      }
    },
    components: {
      'lazy-img': LazyImg,
    },
    computed: {
      actIconImg() {
        return this.$store.state.activity.homeAct.imgUrl || ''
      },
      actInfo() {
        return this.$store.state.activity.homeAct
      },
      visible() {
        return this.$store.state.activity.isHomeActQualified && !this.isScrolling
      }
    },
    methods: {
      clickMe() {
        const actInfo = this.$store.state.activity.homeAct
        const path = resolveActionPath({
          actionData: actInfo.actionData,
          actionType: actInfo.actionType,
        })
        this.$emit('home-act-tip-click')
        this.$router.push(path)
      },
      handleScroll() {
        const self = this
        let flag = 0
        let counter = 0
        let timer = null
        let myTimerFuc = () => {
          return setTimeout(((preflag) => () => {
            if (preflag !== flag) {
              timer = myTimerFuc()
              return
            }
            flag = 0
            clearTimeout(timer)
            timer = null
            self.isScrolling = false
          })(flag), 400)
        }
        return _.throttle(() => {
          self.isScrolling = true
          flag ++
          if (timer) {
            return
          }
          timer = myTimerFuc()
        }, 100)
      },
    },
    mounted() {
      const hs = this.handleScroll()
      if (os.isIOS()) {
        window.addEventListener('touchstart', hs)
      }
      window.addEventListener('scroll', hs)
    },
    beforeDestroy() {
      const hs = this.handleScroll()
      if (os.isIOS()) {
        window.removeEventListener('touchstart', hs)
      }
      window.removeEventListener('scroll', hs)
    }
  }
</script>

<style lang="less" scoped>
  .home-act-tip {
    width: 36px;
    height: 36px;
    z-index: 100;
    position: fixed;
    bottom: 58.7px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

